let _isPreview = false;
export const setIsPreview = () => _isPreview = true;
export const isPreview = () => _isPreview;
